﻿/**
 * LINK SELECTOR BLOCK
 *
 * 
 * @class rlLinkSelector
 * @memberOf jQuery.fn
 **/

(function ($) {

    $.fn.rlLinkSelector = function () {

         ///////////////
         // VARIABLES //
         ///////////////
         const NativeSelect = $('.linkselectorblock section.custom-select-wrapper select');

        //////////////////////////////////////////////////
        //Create an unique id on each version on the page
        /////////////////////////////////////////////////
        $('.linkselectorblock section.custom-select-wrapper').each(function (index) {
            index + 1;
            $(this).attr('id', 'linkcontentselect' + index);
            $(this).find('h2').attr('id', 'linkcllsb' + index)
            $(this).children('label').attr('for', 'linkselectfield' + index);
            $(this).find('select.custom-dropdown-select').attr('id', 'linkselectfield' + index).attr('name', 'linkselectfield' + index).attr('aria-labelledby', 'linkcllsb' + index);            
        });

        ////////////
        // RESETS //
        ////////////

        //clear values on (re)load
        $('.linkselectorblock .custom-dropdown-select').find('option').attr('selected', false);
        $('.linkselectorblock .custom-dropdown-select').find('.linksel-option').attr('selected', true);
       
        let optioncounter = 1;
        const defaultselecttext = 'Select...';

        NativeSelect.on('click', function (e) {
            const thisid = $(this).attr('id');                     

            if ($('#' + thisid).find('.linksel-option').text() != defaultselecttext) {
               $('#' + thisid).find('.linksel-option').text(defaultselecttext);               
            } 
        }).on('focusout', function () {
            optioncounter = 1;
        });

        NativeSelect.on('keydown change', function (e) {
            const keycode = (e.keyCode ? e.keyCode : e.which),
                  optionlength = $(this).find('option').length,
                  thisid = $(this).attr('id');

            let value = this.value;

            function changetext() {
                var optiontext = $('#' + thisid).find('option:nth-child(' + optioncounter + ')').text();

                if (optioncounter == 1) {
                    $('#' + thisid).find('.linksel-option').text(defaultselecttext);
                }
                else {
                    $('#' + thisid).find('.linksel-option').text(optiontext);
                }
                
            }

            //enter & space
            if (keycode == 13 || keycode == 32) {

                if ($('#' + thisid).find('.linksel-option').text() != defaultselecttext) {

                    e.preventDefault();
                    var optiontext = $('#' + thisid).find('.linksel-option').text();
                    var getvalue = $('#' + thisid).find('.option:contains(' + optiontext + ')').val();

                    $('#' + thisid + ' option[value="' + getvalue + '"]').prop('selected', 'selected').change();
                }
            }

            //left & up
            if (keycode == 38 || keycode == 37) {

                if (!(optioncounter <= 1)) {
                    optioncounter--;
                }
                $('#' + thisid).prop('selectedIndex', 0);
                changetext();
                
            }            
            //right and down
            else if (keycode == 40 || keycode == 39) {

                if (!(optioncounter >= optionlength)) {
                    optioncounter++;
                }
                $('#' + thisid).prop('selectedIndex', -1);
                changetext();
                
            }

            else {

                if (typeof (value) !== "undefined" && value) {
                    window.location = this.value;
                    //resets
                    $('#' + thisid).find('.linksel-option').text(defaultselecttext);
                    $('#' + thisid).prop('selectedIndex', 0);
                    $('#' + thisid).focus();
                }

            }
        });
        
    }

}(jQuery));